export function decodeHTMLEntities(url) {
  const parser = new DOMParser()
  const dom = parser.parseFromString(
    `<!doctype html><body>${url}`,
    'text/html',
  )
  return dom.body.textContent
}
